if (!customElements.get('planted-sustainability-calculator')) {
  // ease in out for a smoother animation
  // see https://gizma.com/easing/#easeInOutQuad
  function easeInOutQuad(x) {
    return x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2
  }

  class PlantedCalculator extends HTMLElement {
    connectedCallback() {
      const self = this
      const menuSelector = '[data-calculator-menu]'
      const openerSelector = 'button[data-calculator-opener]'
      let currentProductName = 'planted.steak'
      const openerEl = this.querySelector(openerSelector)
      const menuEl = this.querySelector(menuSelector)
      const buttonEls = this.querySelectorAll('[data-calculator-item]')
      const animalEls = this.querySelectorAll('[data-calculator-animal]')
      const waterBgEl = this.querySelector('[data-calculator-water-bg]')
      const co2BgEl = this.querySelector('[data-calculator-co2-bg]')
      const co2El = this.querySelector('[data-calculator-co2]')
      const waterEl = this.querySelector('[data-calculator-water]')
      const boxesContainerEl = this.querySelector('[data-calculator-boxes]')
      let isOpen = false

      const data = {
        'planted.steak': { animal: 'beef-fillet', co2: 97, water: 81 },
        'planted.chicken': { animal: 'chicken', co2: 77, water: 85 },
        'planted.pulled': { animal: 'pork', co2: 83, water: 75 },
        'planted.kebab': { animal: 'beef', co2: 87, water: 85 },
        'planted.duck': { animal: 'duck', co2: 61, water: 59 },
        'planted.bratwurst': {
          animal: 'beef-bratwurst',
          co2: 71,
          water: 79
        },
        'planted.schnitzel': {
          animal: 'pork-escalope',
          co2: 87,
          water: 90
        }
      }

      let options = {
        rootMargin: '0px',
        threshold: 1.0
      }

      let observer = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            animateBoxes(currentProductName)
            observer.disconnect()
          }
        })
      }, options)
      observer.observe(boxesContainerEl)

      let startTime
      function animateCounter({
        co2El,
        waterEl,
        co2BgEl,
        waterBgEl,
        co2From,
        co2To,
        waterFrom,
        waterTo,
        time
      }) {
        const duration = 1400 // in ms
        const elapsed = time - startTime
        if (elapsed < duration) {
          const elapsedPercentage = easeInOutQuad(elapsed / duration)

          const co2Percentage = co2From + (co2To - co2From) * elapsedPercentage

          co2El.innerText = Math.ceil(co2Percentage)
          co2BgEl.style.top = `${100 - co2Percentage}%`

          const waterPercentage =
            waterFrom + (waterTo - waterFrom) * elapsedPercentage

          waterEl.innerText = Math.ceil(waterPercentage)
          waterBgEl.style.bottom = `${100 - waterPercentage}%`

          window.requestAnimationFrame((time) => {
            animateCounter({
              co2El,
              waterEl,
              co2BgEl,
              waterBgEl,
              co2From,
              co2To,
              waterFrom,
              waterTo,
              time
            })
          })
        } else {
          co2El.innerText = co2To
          waterEl.innerText = waterTo
        }
      }

      const updateMenuVisibility = () => {
        if (menuEl) {
          if (isOpen) {
            menuEl.style.display = ''
          } else {
            menuEl.style.display = 'none'
          }
        }
      }

      if (openerEl) {
        openerEl.addEventListener('click', function (event) {
          isOpen = !isOpen
          updateMenuVisibility()
        })
      }

      document.addEventListener('click', function (event) {
        if (isOpen) {
          try {
            if (
              !event.target.closest(menuSelector) &&
              !event.target.closest(openerSelector)
            ) {
              isOpen = false
              updateMenuVisibility()
            }
          } catch (error) {
            console.error(error)
          }
        }
      })

      function animateBoxes(productName) {
        const productData = data[productName]

        window.requestAnimationFrame((time) => {
          startTime = time

          animateCounter({
            time,
            co2El,
            waterEl,
            co2BgEl,
            waterBgEl,
            co2From: parseInt(co2El.innerText, 10),
            co2To: productData.co2,
            waterFrom: parseInt(waterEl.innerText, 10),
            waterTo: productData.water
          })
        })
      }

      buttonEls.forEach(function (el) {
        el.addEventListener('click', function (event) {
          event.preventDefault()
          const productName = el.getAttribute('data-calculator-item')
          currentProductName = productName
          isOpen = false
          updateMenuVisibility()

          animateBoxes(productName)

          const productData = data[productName]

          const selectedEl = self.querySelector('[data-calculator-selected]')
          selectedEl.innerHTML = el.innerHTML

          buttonEls.forEach(function (someButtonEl) {
            if (el === someButtonEl) {
              someButtonEl.classList.add('hidden')
            } else {
              someButtonEl.classList.remove('hidden')
            }
          })

          animalEls.forEach(function (animalEl) {
            if (
              animalEl.getAttribute('data-calculator-animal') ===
              productData.animal
            ) {
              animalEl.classList.remove('hidden')
            } else {
              animalEl.classList.add('hidden')
            }
          })
        })
      })
    }
  }
  customElements.define('planted-sustainability-calculator', PlantedCalculator)
}
